import { io } from "socket.io-client";

const socket = io("https://mrhealth.co.in", {
  autoConnect: false,
  transports: ["websocket"],
  withCredentials: true,
});

export default socket;

